/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

// Twilio account SID must be 34 characters in length and only allows digits 0-9 and characters A-C & a-f
export const twilioAccountSidRegex = /^[0-9A-Ca-f]{34}$/;

// Twilio auth token must be 32 characters in length and only allows digits 0-9 and characters a-f
export const twilioAuthTokenRegex = /^[0-9a-f]{32}$/;

// Regex not allowing whitespace
export const noSpacesRegex = /^\S*$/;

export const X_WATSON_GENESYS_VERIFICATION_TOKEN =
  'x-watson-genesys-verification-token';
